import {
  createFileRoute,
} from '@tanstack/react-router';
export const Route = createFileRoute('/_app/_authenticated/settings/company')({
  component: RouteComponent,
  loader: async (opts) => {
    const company = opts.context.queryClient.ensureQueryData({
      queryKey: ['company'],
    });
    return company;
  },
});

function RouteComponent(): React.ReactNode {
  const company = Route.useLoaderData() as any;
  return (
    <>
      <h4
        style={ {
          fontSize: '1.4vw',
          fontWeight: '400',
          marginBottom: '1.5vw',
          color: 'rgb(255, 255, 255, 0.7)',
        } }
      >
        Company
      </h4>
      <p
        style={ {
          fontSize: '0.8vw',
          color: 'rgb(255, 255, 255, 0.6)',
          fontWeight: '300',
        } }
      >
        Adjust company details and operational preferences
      </p>
      <div
        style={ {
          display: 'flex',
          fontSize: '0.85vw',
          flexDirection: 'row',
          backgroundColor: 'rgb(255, 255, 255, 0.05)',
          padding: '1vw 1.5vw',
          borderRadius: '0.6vw',
          marginTop: '1.5vw',
          marginBottom: '1.5vw',
        } }
      >
        <div
          style={ {
            flex: 1,
            fontWeight: '600',
          } }
        >
          <p
            style={ {
              margin: 0,
              color: 'rgb(255, 255, 255, 0.8)',
            } }
          >
            Company Name
          </p>
        </div>
        <div
          style={ {
            flex: 1,
          } }
        >
          <p
            style={ {
              textAlign: 'right',
              color: 'rgb(255, 255, 255, 0.7)',
              margin: 0,
            } }
          >
            { company.name }
          </p>
        </div>
      </div>
      <div
        style={ {
          display: 'flex',
          fontSize: '0.85vw',
          flexDirection: 'row',
          backgroundColor: 'rgb(255, 255, 255, 0.05)',
          padding: '1vw 1.5vw',
          borderRadius: '0.6vw',
          marginTop: '1.5vw',
          marginBottom: '1.5vw',
        } }
      >
        <div
          style={ {
            flex: 1,
            fontWeight: '600',
            color: 'rgb(255, 255, 255, 0.8)',
          } }
        >
          <p
            style={ {
              margin: 0,
            } }
          >
            Australian Business Number
          </p>
        </div>
        <div
          style={ {
            flex: 1,
          } }
        >
          <p
            style={ {
              textAlign: 'right',
              color: 'rgb(255, 255, 255, 0.7)',
              margin: 0,
            } }
          >
            { company.abn }
          </p>
        </div>
      </div>
    </>
  );
}
